(function () {
  if (!document.getElementById('sr-redeem-table-body')) return;
  var SHOP = Shopify.shop;
  var APP = 'https://stackr-rewards-production.up.railway.app';
  var TIER_COLORS = {
    Silver: '#94a3b8',
    Gold: '#f59e0b',
    Platinum: '#64748b',
    Titanium: '#334155',
    'Titanium Elite': '#0f172a'
  };

  fetch(APP + '/api/settings?shop=' + SHOP)
    .then(function (r) { return r.json(); })
    .then(function (s) {
      var cn = s.currencyName;
      var cnp = s.currencyNamePlural;

      document.querySelectorAll('.sr-cn-plural').forEach(function (el) { el.textContent = cnp; });
      document.querySelectorAll('.sr-cn').forEach(function (el) { el.textContent = cn; });
      document.querySelectorAll('.sr-earn-rate').forEach(function (el) { el.textContent = s.earnRate; });
      document.querySelectorAll('.sr-bonus-mult').forEach(function (el) { el.textContent = s.bonusMultiplier; });
      document.querySelectorAll('.sr-bonus-thresh').forEach(function (el) { el.textContent = s.bonusThreshold; });
      document.querySelectorAll('.sr-bday-bonus').forEach(function (el) { el.textContent = s.birthdayBonus.toLocaleString(); });
      document.querySelectorAll('.sr-bday-gift').forEach(function (el) { el.textContent = s.birthdayGift.toLocaleString(); });
      document.querySelectorAll('.sr-referral-bonus').forEach(function (el) { el.textContent = s.referralBonus.toLocaleString(); });
      document.querySelectorAll('.sr-referral-welcome').forEach(function (el) { el.textContent = s.referralWelcome.toLocaleString(); });
      document.querySelectorAll('.sr-min-redeem').forEach(function (el) { el.textContent = s.minRedemption.toLocaleString(); });
      document.querySelectorAll('.sr-min-redeem-dollars').forEach(function (el) { el.textContent = (s.minRedemption / s.pointsPerDollar).toFixed(0); });

      var tbody = document.getElementById('sr-redeem-table-body');
      if (tbody) {
        var rows = '';
        for (var i = 1; i <= 6; i++) {
          var pts = s.minRedemption * i;
          var off = pts / s.pointsPerDollar;
          var bg = i % 2 === 0 ? ' style="background:#fafafa"' : '';
          var border = i < 6 ? 'border-bottom:1px solid #f0f0f0;' : '';
          rows += '<tr' + bg + '>'
            + '<td style="padding:10px 16px;' + border + '">' + pts.toLocaleString() + ' ' + cnp + '</td>'
            + '<td style="padding:10px 16px;' + border + 'font-weight:700;color:#09728c;">$' + off.toFixed(0) + ' off</td>'
            + '</tr>';
        }
        tbody.innerHTML = rows;
      }

      var grid = document.getElementById('sr-tiers-grid');
      if (grid) {
        var tiers = [
          { name: 'Silver', thresh: s.silverThreshold, mult: s.silverMultiplier, annual: true },
          { name: 'Gold', thresh: s.goldThreshold, mult: s.goldMultiplier, annual: true },
          { name: 'Platinum', thresh: s.platinumThreshold, mult: s.platinumMultiplier, annual: true },
          { name: 'Titanium', thresh: s.titaniumThreshold, mult: s.titaniumMultiplier, annual: true },
          { name: 'Titanium Elite', thresh: s.titaniumEliteThreshold, mult: s.titaniumEliteMultiplier, annual: false }
        ];
        grid.innerHTML = tiers.map(function (t) {
          var c = TIER_COLORS[t.name] || '#09728c';
          return '<div style="background:#fff;border:2px solid ' + c + ';border-radius:10px;padding:16px 14px;text-align:center">'
            + '<div style="font-weight:800;font-size:16px;color:' + c + ';margin-bottom:6px">' + t.name + '</div>'
            + '<div style="font-size:24px;font-weight:800;color:#09728c;line-height:1">' + t.mult + 'x</div>'
            + '<div style="font-size:12px;color:#6b7280;margin-top:6px">' + t.thresh.toLocaleString() + ' ' + cnp + ' ' + (t.annual ? 'annually' : 'lifetime') + '</div>'
            + '</div>';
        }).join('');
      }
    })
    .catch(function (e) { console.warn('Stackr fetch failed', e); });
})();
